import React from "react"
import PropTypes from "prop-types"

// Material UI
import { makeStyles, fade } from "@material-ui/core/styles"
import {
  Grid,
  Typography,
  Chip,
  Dialog,
  DialogTitle,
  DialogContent,
  IconButton
} from "@material-ui/core"

// Icons
import CloseIcon from "@material-ui/icons/Close"

const useStyles = makeStyles(theme => ({
  chipRoot: {
    backgroundColor: fade(theme.palette.grey.pearlGrey, 0.3),
    color: theme.palette.grey.carbon
  },
  dialogPaper: {
    border: `1.5px solid ${theme.palette.primary.main}`
  },
  dialogTitleRoot: {
    padding: theme.spacing(1, "inherit")
  },
  contentContainer: {
    padding: theme.spacing(0, 3, 3, 3)
  },
  closeIcon: {
    color: theme.palette.common.black,
    backgroundColor: fade(theme.palette.grey.pearlGrey, 0.4),
    padding: theme.spacing(1)
  }
}))

export default function AllSkillsDialog({ open, handleClose, skills }) {
  const classes = useStyles()

  return (
    <Dialog
      classes={{
        paper: classes.dialogPaper
      }}
      fullWidth
      maxWidth={"md"}
      open={open}
      onClose={handleClose}
      aria-labelledby="form-dialog-title"
    >
      <DialogTitle
        classes={{
          root: classes.dialogTitleRoot
        }}
        id="form-dialog-title"
      >
        <Grid container justifyContent="space-between" alignItems="center">
          <Grid item>
            <Typography variant="h6" className="text-medium">
              Skills you will learn
            </Typography>
          </Grid>
          <Grid item>
            <IconButton
              size="small"
              className={classes.closeIcon}
              aria-label="close"
              onClick={handleClose}
            >
              <CloseIcon />
            </IconButton>
          </Grid>
        </Grid>
      </DialogTitle>

      <DialogContent className={classes.contentContainer}>
        <Grid container spacing={2}>
          {skills.map((skill, index) => (
            <Grid item key={index}>
              <Chip
                classes={{ root: classes.chipRoot }}
                label={
                  <Typography variant="body2" className="text-capitalize">
                    {skill}
                  </Typography>
                }
              />
            </Grid>
          ))}
        </Grid>
      </DialogContent>
    </Dialog>
  )
}

AllSkillsDialog.propTypes = {
  open: PropTypes.bool,
  handleClose: PropTypes.func,
  skills: PropTypes.array
}
